// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import Axios from 'axios';
import store from './store';
import router from './router';
import VueI18n from 'vue-i18n';
import VueGmaps from 'vue-gmaps';
import Resource from 'vue-resource';
import * as filters from './filters';
import globals from './config/globals';
import auth from '@/services/AuthService';
import { ServerTable } from 'vue-tables-2';
import VueSweetalert2 from 'vue-sweetalert2';
import TheModal from './components/widgets/TheModal.vue';
import CustomLoading from '@/components/widgets/customLoading';
import Notifications from 'vue-notification';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueLayoutComposer from 'vue-layout-composer';
import { getSystemSettings } from './utils/index';

import { API_BASE_URL } from '@/config';
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
import BootstrapVue from 'bootstrap-vue';
import './assets/css/leaflet.draw.css';
import Vuelidate from 'vuelidate';
import VueFormGenerator from 'vue-form-generator';
import 'vue-form-generator/dist/vfg.css';
import Multiselect from 'vue-multiselect';
import fieldDatetime from '@/components/widgets/FieldDatetime';
import fieldChooser from '@/components/widgets/FieldChooser';
import flatPickr from 'vue-flatpickr-component';
const options = {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674',
};
Vue.use(VueFormGenerator);
Vue.use(VueSweetalert2, options);
Vue.use(Resource);
Vue.use(BootstrapVue);
Vue.use(Notifications);
Vue.use(VueLayoutComposer);
Vue.use(ServerTable, {}, false);
Vue.use(VueGmaps, {
  key: 'AIzaSyD5UPc7IXZ7oVOCLuCqU58idrPkZQYDW58',
});
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD5UPc7IXZ7oVOCLuCqU58idrPkZQYDW58',
    libraries: 'places,geometry',
  },
  installComponents: true,
});
Vue.use(Vuelidate);
Vue.component('multiselect', Multiselect);
Vue.component('flatPickr', flatPickr);
Vue.component('fieldDatetime', fieldDatetime);
Vue.component('fieldChooser', fieldChooser);
Vue.component('custom-loading', CustomLoading);
Vue.component('the-modal', TheModal);
// ------- CUSTOM DIRECTIVE -------
Vue.directive('can', {
  bind: function (el, binding, vnode) {
    if (!JSON.parse(localStorage.getItem('permissions')).includes(binding.value.replace(/'/g, '').replace(/"/g, ''))) {
      vnode.elm.style.display = 'none';
    }
  },
});

Vue.http.interceptors.push(function (request, next) {
  // Add JWT to all requests
  request.headers.set('Accept', 'application/json');
  request.headers.set('Content-Type', 'application/json');
  request.headers.set('Authorization', auth.getAuthHeader());
  // Skip storing token refresh requests
  next(function (response) {
    auth.checkExpiredToken(response).then(function (response) {
      return response;
    });
  });
});

Vue.config.productionTip = false;

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
Vue.prototype.$filters = Vue.options.filters;

Vue.mixin({
  data: globals,
});

Axios.post(API_BASE_URL + 'ats/get_keyword_translations', {})
  .then(async data => {
    // ------- LANG ------------
    Vue.use(VueI18n);
    const i18n = new VueI18n({
      locale: store.getters.lang,
      fallbackLocale: 'tr',
      messages: data.data,
    });
    // ------- LANG ------------
    getSystemSettings();
    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      router,
      i18n,
      store,
      components: { App },
      template: '<App/>',
    });
  })
  .catch(() => {
    // ------- LANG ------------
    Vue.use(VueI18n);
    const i18n = new VueI18n({
      locale: store.getters.lang,
      fallbackLocale: 'tr',
      messages: {},
    });
    // ------- LANG ------------

    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      router,
      i18n,
      store,
      components: { App },
      template: '<App/>',
    });
  });
